import { configureStore } from '@reduxjs/toolkit';
import userReducer from './slices/userSlice';
import serviceReducer from './slices/serviceSlice';


export const store = configureStore({
  reducer: {
    user: userReducer,
    service: serviceReducer,
  },
});
// before able to update eslint version to latest
// eslint-disable-next-line no-undef
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
